import moment from 'moment'
import {v4 as uuidv4} from 'uuid'

const CommonUtils = {
  limit: (arr, nb = 20) => arr.slice(0, nb),
  flatMap (array) {
    return array.reduce((finalArray, currentArray) => [...finalArray, ...currentArray], [])
  },
  toPostgreDatetime(date) {
    return moment(date, 'YYYY-MM-DD HH:mm:ss').toDate()
  },
  sumArray: (array, parameters) => array.reduce((sum, element) => sum + parseFloat(element[parameters]), 0),
  sumDictionnary: (dictionnary, parameters) => CommonUtils.sumArray(dictionnary.map(pair => pair.value), parameters),
  addToDictionnary: (dictionnary, element, lifo = false) => {
    const newElement = {key: uuidv4(), value: element}
    if (lifo) {
      return [].concat(newElement, dictionnary)
    }
    return [].concat(dictionnary, newElement)
  },
  createDictionnaryEntry: element => ({key: uuidv4(), value: element}),
  removeDictionnary: array => array.map(element => element.value),
  getOrElse: (option, recover) => {
    if (parseFloat(option)) { return parseFloat(option) }
    return option || recover
  },
  getOrElseString: (option, recover) => option || recover,
  lengthArray: array => array.reduce(length => length + 1, 0),
  toBoolean: boolean => String(boolean) === 'true' || String(boolean) === '1',
  parseNumber: value => {
    if ((!value && value !== 0) || value === '' || value === 'null' || value === 'undefined') {
      return undefined
    }
    if (!isNaN(value) && value !== null) {
      return parseFloat(value)
    }

    return value
  },
  normalizeText(text)  {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  },
  removeWithIndex: (array, index) => array.reduce((array, element, indexArray) => {
    if (index !== indexArray) return [...array, element]
    return array
  }, []),
  dictionnaryFromArray: (array = []) => array.map(element => ({
    key: uuidv4(),
    value: element
  }))
}
export default CommonUtils
